export default {
    title: "Articles non livrés",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Merci",
        message: "Merci pour votre réponse."
    },
    message: "Vous avez indiqué que vous n'avez pas reçu votre article malgré le fait que le transporteur l'ait marqué comme livré.",
    cta: "Veuillez suivre ces étapes pour nous aider à résoudre le problème :",
    items: {
        1: {
            message: "Cliquez sur le(s) lien(s) de suivi :"
        },
        2: {
            message: "Vérifiez l'état de la livraison. Vérifiez :",
            items: {
                1: "Qui a signé pour le colis",
                2: "Si a été retourné à l'expéditeur",
                3: "Si le colis est en attente de retrait"
            }
        },
        3: {
            message: "Vérifiez s'il y a un avis de livraison indiquant où l'article a pu être laissé."
        },
        4: {
            message: "Vérifiez auprès des voisins, des proches et des amis qui ont peut-être pris le colis."
        }
    },
    question: "Cela a-t-il résolu votre problème de livraison ? Avez-vous maintenant l'article ou savez-vous qui l'a ? Veuillez répondre ci-dessous.",
    product: {
        name: "Nom de l'article",
        quantity: "Quantité",
        tracking: "Suivi",
    },
    buttons: {
        yes: "Oui",
        no: "Non",
        saving: "Économie"
    }
}